import Logger from 'core/utils/Logger'

export const isDomainMatching = (email: string, website: string) => {
  const emailDomain = getEmailDomain(email)
  const urlDomain = getWebsiteDomain(website)

  if (!emailDomain || !urlDomain) {
    Logger.warn('Verification is not possible. The email or website is incorrect.')
    return false
  }

  return emailDomain === urlDomain
}

export const isEmailDomainInList = (email: string, emailList: string[]) => {
  const emailDomain = getEmailDomain(email)
  if (!emailDomain) return false

  return emailList.some((item) => getEmailDomain(item) === emailDomain)
}

export const getEmailDomain = (email: string): string => {
  if (!email) return ''
  const trimmedEmail = email.trim()
  const parts = trimmedEmail.split('@')

  return parts.length === 2 ? parts[1].toLowerCase() : ''
}

export const getWebsiteDomain = (website: string) => {
  const trimmedWebsite = website.trim()
  if (!trimmedWebsite) return ''

  const normalizedWebsite =
    trimmedWebsite.startsWith('http://') || trimmedWebsite.startsWith('https://')
      ? trimmedWebsite
      : `https://${trimmedWebsite}`

  return new URL(normalizedWebsite).hostname.replace(/^www\./, '').toLowerCase()
}
